import {DomEvent} from 'leaflet';
import {useCallback, useEffect} from 'react';
import {useMap} from 'react-leaflet';

import {useCluster} from './useCluster';

import type {GeoFeatureProperties} from '../../functions/createGeoFeatures';
import type {Map} from 'leaflet';
import type {ClusterFeature, PointFeature} from 'supercluster';
import type Supercluster from 'supercluster';

type Props<P extends GeoFeatureProperties> = {
  markers: PointFeature<P>[];
  minZoom: number;
  maxZoom: number;
  children: (
    map: Map,
    markers: PointFeature<P>[],
    clusters: ClusterFeature<P>[],
    sc: Supercluster<P, P>
  ) => React.ReactNode;
};
export function MapController<P extends GeoFeatureProperties>(
  props: Props<P>
): React.JSX.Element {
  const [markers, clusters, sc] = useCluster<P>(props.markers, {
    minZoom: props.minZoom,
    maxZoom: props.maxZoom,
  });

  // prevent clicks on overlying ui propagating to map
  const toolbarRef = useCallback((node: HTMLDivElement) => {
    if (node) {
      DomEvent.disableClickPropagation(node);
    }
  }, []);

  const map = useMap();

  // disable contextmenu so right click pan works as expected
  useEffect(() => {
    map.getContainer().addEventListener('contextmenu', (e) => {
      DomEvent.preventDefault(e);
    });
  }, [map]);

  // DISABLED BECAUSE OF JUMPINESS ON CONNECT IMAGE OPEN
  // APPEARS TO CENTRE ON FIRST RENDER JUST FINE WITHOUT IT
  // LEAVING FOR POSSIBLE FUTURE USE
  // centre map around items on load
  // useEffect(() => {
  //   try {
  //     map.fitBounds(props.initialBounds, {animate: false});
  //   } catch (e) {
  //     console.warn('Swallowing map pan animation error');
  //   }
  // }, [map, props.initialBounds]);

  return (
    <div ref={toolbarRef}>{props.children(map, markers, clusters, sc)}</div>
  );
}

MapController.displayName = 'MapController';
